export default __webpack_public_path__ + "static/media/travel.250f3d00.png";